module.exports = __webpack_public_path__ + "static/media/jira-logo.2451cb62.png";